import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Comparing clojure and node.js for speed",
  "description": "",
  "published": "2011-04-07T00:00:00.000Z",
  "redirect_from": ["/blog/comparing-clojure-and-node-js-for-speed/swizec/1593"],
  "categories": "Uncategorized",
  "hero": "./img/tumblr_lja8awZaYe1qekjngo1_500.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`For the longest of whiles I've been working on a speed comparison between Node.js and Clojure. Today I had some time in a place with unreliable internets and finally gave it a whirl since there was nothing better to do, I certainly wasn't going to merely enjoy the sun.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "500px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/2264fcad194237562d6cb9f922ee8a07/41099/tumblr_lja8awZaYe1qekjngo1_500.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'400\\'%20viewBox=\\'0%200%20400%20400\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M45%207L11%208%207%2020%206%20218a4215%204215%200%20011%20161c1%209%202%2012%207%2013%208%202%2048%203%20122%203h137c68%200%20111-1%20114-4s4-24%204-54l-1-160c0-167%201-162-4-166-3-3%209-3-155-3A18414%2018414%200%200145%207m182%2043l-9%201-14%201c-10%202-19%202-20%201s-8%201-8%202l-4%201-4%201-6%203c-3%200-6%202-7%203l-6%201c-6%200-21%206-21%208l-3%201c-4%200-13%203-13%204l-4%202-4%201c0%202-12%208-15%208l-1%201c0%202-7%203-8%202h-1c0%202-4%206-6%206l-1%201-9%204-4%202-7%205c-4%202-11%208-11%2010l-2%201-4%202-3%202-4%204c-1%201-2%203-4%203-4%200-10%207-10%2014l-1%2054-1%2050h10c10%200%2014-2%2014-6%201-3%203-4%204-1l1%202%201%201c-1%203%206%209%208%207s1-3-1-4c-3%200-4-1-1-2h2c2-2%201-6-1-10l1-2%202-2c1-6%202-5%201%200%200%205%201%209%204%209l1%202v6l-2%202-1%203-1%203c0%202%200%203%201%202l3-3%202-7%202-7c1-3%202-4%200-7v-5c0-2%203-2%203%200s3%201%203-2l1-3%202%203c2%203%202%204%201%204l-1%202-1%201v6c2%202%202%202%200%202-2%201-3%204-1%204l1-1v-1l1%202%201%202v1c0%201%200%202%202%201%201%200%202%200%202%202h1v-3c-1-1-1-1%201-1l1-1v-2l1%202c-1%203%202%202%203-1%201-2%201-2%203%200%202%203%202%203%200%205-1%202-3%202-5%202-1-1-2-1-1%201l-1%204c-1%202-1%205%201%205l1-1%201-2v-1l1-3c2-1%202-1%204%203l3%202h2c1%201%201%201%201-1-1-2%200-3%201-3l1-1v-5l1%202c1%201%201%201%201-1%200-3%200-3-1-2-2%201-4-1-3-4l-1-2-2-2%203-1c1%201%202%200%202-1l1-1%202-1%201-2-2-4c-1-4-2-5-6-3-2%202-3%202-3%201%201-3%207-5%208-3%201%201%201%200%201-3%200-4%201-5%201-1l2%202-1%202-1%202h2v2c0%203%201%204%203%202h1l-1%202c-3%201-3%2012%200%2011l1%202-1%201c-1-1-2%200-2%204s0%205%203%203c1-1%203-6%201-6l1-2%202-1c1%201%201%200%201-1v-1h1l2-7%203-3c4-6%206-7%205-4h3l1-1v1l-1%203-1%201c-1-1-5%201-5%203l-1%201c-1-1-6%209-5%2010%202%202%205-3%205-6v-3l1%204c0%201%200%202%201%201%202%200%202%200%201%201l-2%202c-2%200-1%201%201%204l4%205c1%201%202%202%205%201l4%201c0%201%201%202%203%202s3%201%200%203c-1%201-1%201%201%202l2%202-1%202-1-1h-2l2%202v2c-2%201%201%202%203%200s1%200-1%203l-1%203h22l2-1v-2h5l-3-2c-2-3-3-4%200-3v-2c-2-2-1-4%201-2s3%201%202-1c-2-2-2-2%201-3l3-1c1-1%201%200%202%202%200%203%200%203%202%201h2v2c2%200%203%202%203%206l1%203c5-2%205-2%204%200%200%201%200%202%202%201%202%200%203-4%201-4v-2l3-1h2l3-1%204-1%202-1%203-1%203-1h23c1%201%207%201%207-1%200-1%202-1%202%201l5%201h5v-6l1-6c1-1%201%200%201%201l1%204%201%204c1%204%206%204%207%200l5-6c6-3%208-4%206-1v1h2l2%202c2%202%203%201%201-1-1-2-1-4%201-2%201%201%202%200%203-2s2-3%205-2c4%200%204%200%201%201l-3%203v2l3-2%204-3-1-1c-3-3-1-8%202-8%201%200%202-3%201-5l1-1%202%206v2h2l1%202c0%203%203%202%204-1l2-3v3c1%203%202%203%205%203l3%201h12c11%200%2012-1%2018-4%2011-7%2012-8%2011-14l-1-7c-3-8-3-7%200-12l5-7%203-3%205%202%209%203c5%200%202-2-3-2-2%200-3%200-1-1l2-1h2l6%201%205-1V104l-3-2-3-5-3-1-4-1-6-4-5-2-4-1h-4v-8h-4l-4-1-5-3c-6%200-10-2-13-5-1-1-3-2-4-1l-2-1-4-2h-4l-4-1c-1-2-8-4-11-4-5-1-9-2-9-4l-5-1c-5%201-6%201-6-1-1-2-1-2-2-1s-10%200-12-2-4-1-5%201c0%202-2%203-2%201s-18-4-19-3h-5l-1-1-2-1-1-2-1%202M25%20283c1%2015%201%2013%203%2013l1%201c0%201%204%202%205%200l3-2c3%200%204-2%202-2l-3-3c0-2-1-2-3-2h-2c0-1%202-3%207-4%206-2%207-5%200-7l-7-4c-6-5-6-5-6%2010m209%202v22l3-3c2-2%203-2%203-1-1%201%200%202%201%202v-3c-1-1%200-4%201-3l1-1v-5c-2-2-2-3%200-3v-1l-1-2-3-2-3-1-2%201m-21%204l-1%206c-1%200-1%2013%201%2021%200%203%200%203%202%201%202-3%205-10%205-13l2-2c2%200%202-1%202-3%200-3%200-3-3-3-4%200-6-2-6-10l-1-1-1%204m-32%2011c1%208%202%2013%204%209h2c2%201%202%201%202-4l1-5v-6c0-3%200-3-5-3h-4v9M54%20332l-12%204-24%208c-5%202-6%203-6%206%201%204%201%204%206%202%202-1%205-2%206-1l4-1c1-1%201-1-1-1-3%200-2-1%203-3%208-2%2015-5%2022-10l6-3c1%201%206-1%206-3l-10%202m171%2014c-4%200-4%202%200%203h3v12l1%203c0%202%200%203%204%202%203%200%203%200%201-1l-2-2c0-1-1-1%2033-2h28l-10-4c-6-2-9-4-7-4%204-1%202-2-4-2-8%200-18-4-14-5h-33m5%2032c0%204%200%205%205%208l10%203h5v-8l1%204c1%204%205%206%206%202l1-2v2a193%20193%200%200038%202l-5-3-4-3%207%203%206%203h38c47%200%2047%200%2036-4l-10-4a710%20710%200%2000-79%201v1l-2-1-11-1c-11%200-11%200-16-3-3-3-6-3-10-4h-6v4l-1%205v-5c0-3%200-4-2-4-1%200-2%201-2%203v3l-1-3c-1-6-4-5-4%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2264fcad194237562d6cb9f922ee8a07/ca0a1/tumblr_lja8awZaYe1qekjngo1_500.webp 223w", "/static/2264fcad194237562d6cb9f922ee8a07/75680/tumblr_lja8awZaYe1qekjngo1_500.webp 445w", "/static/2264fcad194237562d6cb9f922ee8a07/b0a15/tumblr_lja8awZaYe1qekjngo1_500.webp 500w"],
                "sizes": "(max-width: 500px) 100vw, 500px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2264fcad194237562d6cb9f922ee8a07/853b2/tumblr_lja8awZaYe1qekjngo1_500.jpg 223w", "/static/2264fcad194237562d6cb9f922ee8a07/0a4fe/tumblr_lja8awZaYe1qekjngo1_500.jpg 445w", "/static/2264fcad194237562d6cb9f922ee8a07/41099/tumblr_lja8awZaYe1qekjngo1_500.jpg 500w"],
                "sizes": "(max-width: 500px) 100vw, 500px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/2264fcad194237562d6cb9f922ee8a07/41099/tumblr_lja8awZaYe1qekjngo1_500.jpg",
                "alt": "tumblr lja8awZaYe1qekjngo1 500",
                "title": "Sun at Rimski Zid",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Sun at Rimski Zid`}</figcaption>{`
  `}</figure>{`The comparison I chose to go for is hard computation - namely calculating a list of primes up to a certain number. Why this test? Because primes are awesome!`}</p>
    <p>{`I did my best to implement the same algorithm in both. It creates a list of numbers from 3 to N, then filters it of anything that isn't a prime. Through a bit of trial and error this turned out to be the quickest approach, possibly because it means we can run prime-ness tests in parallel on several numbers.`}</p>
    <p>{`For node.js I also implemented a bit different algorithm that builds a list of known primes and iterates through that instead of everything under the square root of the target. It can't run in parallel, but turns out it's faster ... couldn't figure out how to implement it in clojure to be fast as you can see from my post on `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/checking-for-primes-dumber-algorithm-is-faster-algorithm/swizec/1580"
      }}>{`prime searching in clojure`}</a>{`.`}</p>
    <p>{`As far as initial observations go there were a few interesting things I discovered:`}</p>
    <ol>
      <li parentName="ol">{`Node is super fast for heavy but small calculations and seems to break down for large datasets.`}</li>
      <li parentName="ol">{`Clojure really benefits from native implementations of filter and such. I suspect that they are running in parallel because it is consistently burning 15+ threads.`}</li>
      <li parentName="ol">{`Jacking up the max N to 100,000,000 caused a memory allocation error in the classic node.js algorithm, but worked fine with the cutesier one.`}</li>
      <li parentName="ol">{`Both Node and Clojure were burning around 600 megs of RAM when doing the 1M test`}</li>
    </ol>
    <p>{`The computer I was testing on is my trusty MBP with 4gigs of RAM and a 2.4gig core2duo. To avoid as much artefacts as possible each test was run five times and the average runtime was calculated. Just in case it's relevant, the computer was running on battery at the time, there's a slight chance this means the CPU was clocked down.`}</p>
    <h2 {...{
      "id": "the-code"
    }}>{`The code`}</h2>
    <p>{`This is the basic implementation in node.js, the more cutesy algorithm just uses a global array of known primes and iterates over those, but otherwise the code is the same so it'd be silly to post it twice.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`var async = require('async');

var isPrime = function (n, callback) {
    if (n%2 == 0) {
    callback(false);
    return;
    }else{
    var root = Math.sqrt(n);
    for (var i=3; i<=root; i += 2) {
        if (n%i == 0) {
        callback(false);
        return;
        }
    }
    }
    callback(true);
}

var primes = function (n, callback) {
    var acc = new Array();

    for (var i=2; i<n; acc.push(i++));<p="">

    async.filter(acc, isPrime, function(results){
    results.unshift(2);
    callback(results);
    });
}

primes(process.argv[2], function (result) {
});
</n;>
`}</code></pre>
    <p>{`This is practically the same code in clojure:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-lisp"
      }}>{`(defn prime? [n]
  (if (even? n) false
      (let [root (num (int (Math/sqrt n)))]
    (loop [i 3]
      (if (> i root) true
          (if (zero? (mod n i)) false
          (recur (+ i 2))))))))

(defn primes [n]
  (let [nums (loop [i 2 acc []]
           (if (> i n) acc
           (recur (inc i) (cons i acc))))]
    (concat (filter prime? nums) [2])))

(primes (Integer/parseInt (first *command-line-args*)))
`}</code></pre>
    <p>{`Immediately we can see that the clojure code is much more concise; which code is more readable is a bit harder to say. Personally I'd lean towards javascript for readability, but there is a certain level of elegance in lisp.`}</p>
    <p>{`This is the code I used to run the tests. You can see for each run a process is spawned and the cleanest possible time is measured. This helps us avoid any memory leaking issues that could slow down the code, but introduces a small penalty for spawning processes. I'm assuming this penalty is constant.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`var spawn = require("child_process").spawn;

var N = 100000000;

var runs = function (n, i, avg) {
  var i = i || 0;
  var avg = avg || 0;

  var before = new Date().getTime();
  var child = spawn("node", ["many-primes.js", N], { cwd: __dirname });
  //var child = spawn('clj', ['many-primes.clj', N], {cwd: __dirname});

  child.on("exit", function (code) {
    var time = (new Date().getTime() - before) / 1000;

    console.log(time);
    if (i < n) {
      runs(n, i + 1, avg + time);
    } else {
      console.log(avg / n);
    }
  });
};

runs(5);
`}</code></pre>
    <h2 {...{
      "id": "the-results"
    }}>{`The results`}</h2>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "595px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/e89d5f795fb4ed152d81e1fe63b67881/3dd3e/BkTG0.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "9.865470852017937%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'40\\'%20viewBox=\\'0%200%20400%2040\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M259%205l-2%203h20c6%200%208-1%206-4-1-2-10-2-11%200%200%202%200%202-2%200-1-2-2-2-2-1h-2c-2-2-6-1-7%202m52-2c0%203%201%205%203%205h21c5%200%207-2%205-4-1-2-9-2-10%200-2%202-2%202-3%200%200-1-2-2-5-1-6%200-6%200-6%202l-2-1c-2-2-2-2-3-1m53%201c-1%202%201%204%204%204h24c5-1%206-1%206-3l-1-2c-6-1-9%200-11%201l-1%201c0-2%200-2-6-2-3-1-5%200-5%201-1%202-1%202-3%200-1-2-6-2-7%200M23%2032l-6%201c-5%200-5%200-5%203s2%203%202%200c1-2%201-2%201%200s4%203%204%201l1-1%201%201h8c1%202%205%201%207-1h3c1%202%201%202%202%201h6c0-2%201-2%202-1h1c0-1%201-1%202%201%202%201%202%201%202-2l-2-2a655%20655%200%2000-29-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e89d5f795fb4ed152d81e1fe63b67881/ca0a1/BkTG0.webp 223w", "/static/e89d5f795fb4ed152d81e1fe63b67881/75680/BkTG0.webp 445w", "/static/e89d5f795fb4ed152d81e1fe63b67881/536c8/BkTG0.webp 595w"],
                "sizes": "(max-width: 595px) 100vw, 595px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e89d5f795fb4ed152d81e1fe63b67881/e92b6/BkTG0.png 223w", "/static/e89d5f795fb4ed152d81e1fe63b67881/e66bf/BkTG0.png 445w", "/static/e89d5f795fb4ed152d81e1fe63b67881/3dd3e/BkTG0.png 595w"],
                "sizes": "(max-width: 595px) 100vw, 595px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/e89d5f795fb4ed152d81e1fe63b67881/3dd3e/BkTG0.png",
                "alt": "BkTG0",
                "title": "The raw data",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`The raw data`}</figcaption>{`
  `}</figure></p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "431px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/1b74da432e239af365d02f1d22e104fd/9cb4e/22s7m.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "73.09417040358744%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'292\\'%20viewBox=\\'0%200%20400%20292\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M187%2015c-2%203-1%205%202%206l3-1h8c0%202%203%201%203-1l1-2v2l1%202c1%200%202-1%201-2l1-2%201%202%201%202%202%201h2l8-1c6%200%207%200%207-2l1-2%201%202c0%202%201%202%208%202l8-1h1l1%201%201-2%201-2%201%202%201%202%201-3c0-3-1-3-3-3l-3%201h-1c0-2-3-2-5%200s-3%203-2%201c0-2-3-3-4-2h-12c-1-1-4%200-4%202l-2-1c-1-2-5-2-6%200h-1c-1-2-9-2-10%200h-1c0-2-3-2-5%200s-6%204-6%202l2-1c2%200%203-2%200-2h-3m165%2040v5c2%203%202%203-2%2013l-3%209H60l143%201%20143%201a380%20380%200%2001-15%2042l-2%205H194l-134%201h269l-1%202a410%20410%200%2000-15%2041l-2%204H185l-125%201h251l-3%209c-4%2010-4%2011-6%209-3-2-8-1-10%203-2%205-47%2022-50%2020-3-3-5-2-9%201l-3%202h-22c-21%200-22%200-25-2-3-3-6-3-9%200s-48%203-50%200c-3-3-7-3-9%200-2%202-4%202-26%202s-23%200-25-2c-4-4-11-1-11%205%200%207%206%2010%2011%206l3-3h23l23%201%203%203c2%201%203%202%202%203-2%202-1%205%202%206l2-1h7c0%202%204%201%205-2%200-4-3-6-4-4l-2%201c-1-2-2-2-4-1h-3c-2-2-2-2%200-2l3-2c1-2%202-2%2024-2h24l2%203%204%202%205-2%203-3h23c21%200%2023%200%2024%202%202%202%208%202%2010-1l2-2h114l-56-1-52-1%2023-3%2017-2%203%202c5%204%2010%200%2010-8%200-4%2045-36%2051-36%207%200%2011-7%207-11s-11-1-11%204-3%206-21%206h-16l5-14%209-24%203-9h27l-13-1c-12%200-13%200-13-2a1807%201807%200%200015-38l2-8h9l-4-1-4-1c6-16%206-17%209-18s4-2%204-5c0-6-7-9-11-3m-39%20127l-3%207a216%20216%200%2001-7%2020l21-14%2020-15h-15c-13%200-15%200-16%202m-36%2031l-14%206%2014-2c12-2%2014-2%2016-5s2-3%201-4c-2-1-1-2-17%205M56%20236l-1%204c0%203%202%204%205%202h1l5%201c5%200%207-2%205-6-1-2-2-2-4-1h-5c-1%201-2%202-3%200h-3m125%200l-1%204c0%203%200%203%205%203l5-1h1c3%202%205%200%205-3s-1-4-4-3h-11m43%201c-2%204%200%206%205%206l5-1h1c3%203%207-1%205-5-1-2-2-2-4%200-1%201-1%201-3-1h-5c-2-1-3-1-4%201m20-1c-2%203%200%207%202%207l2-1h7c3%202%205%200%205-2%200-4-3-6-4-4-2%202-2%202-3%200h-9m43%200c-2%203-1%206%201%207l3-1h7l3%201h2l1%201%201-2h-1l-1-2c0-4-3-6-4-4-2%202-2%202-3%200h-9m20%200l-1%203c0%204%203%205%205%202h1c0%203%2010%202%2010%200%200-5-1-7-3-5h-3c-2-1-4-1-4%202l-2-1c-1-2-2-2-3-1m42%201c-2%204%200%206%205%206%204%200%205-1%205-2h1c2%203%205%202%205-2-1-4-4-5-5-2l-1%201c0-3-2-3-4-2h-2c-2-1-3-1-4%201m20-1l-1%204-1%202h-1l1%202%201-1h3c1%200%202%200%202-2h1c1%202%205%203%205%201h1c1%202%204%201%205-2%200-4-3-6-4-4-2%202-2%202-3%200h-3l-2%201c-1-2-2-2-4-1m-223%2032l-2%201-2%201h-9l-3-1c-2%200-2%200-2%204%200%202%200%203%201%202l1-1%201-4%201%203%201%203%201-2%201%201h8c3%202%205%201%205-4l-1-5-1%202m100-1l-2%202-2%201h-9l-2-1c-3%200-3%200-3%204l1%203%201-4%201-2%201%203c0%203%200%203%201%202h17c1%202%203%201%204-1%201-3%200-5-3-5l-2%201c-1%201-1%201-1-1s-2-4-2-2m26%205c0%204%202%205%205%203h5c2%202%204%200%204-3%200-2%200-2%202%201%201%203%201%203%203%202l1-4%201%202c0%202%201%203%203%203s3-1%203-3c0-3-1-4-4-4s-4%201-5%202c-1%202-1%202-1%200-1-2-8-3-8-1h-1c-2-1-2-1-2%201l-1%202v-2c0-1-1-2-3-2s-2%200-2%203\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/1b74da432e239af365d02f1d22e104fd/ca0a1/22s7m.webp 223w", "/static/1b74da432e239af365d02f1d22e104fd/01668/22s7m.webp 431w"],
                "sizes": "(max-width: 431px) 100vw, 431px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/1b74da432e239af365d02f1d22e104fd/e92b6/22s7m.png 223w", "/static/1b74da432e239af365d02f1d22e104fd/9cb4e/22s7m.png 431w"],
                "sizes": "(max-width: 431px) 100vw, 431px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/1b74da432e239af365d02f1d22e104fd/9cb4e/22s7m.png",
                "alt": "22s7m",
                "title": "First graph",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`First graph`}</figcaption>{`
  `}</figure></p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "389px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/76b657620103638367aa6110aaeaeeeb/00a4e/qXPSS.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "79.37219730941703%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'318\\'%20viewBox=\\'0%200%20400%20318\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M178%2018v5h7c7%200%207-1%208-3l1-2v2c0%204%202%204%202%201%200-4%202-4%202-1l2%203c2%200%202-3%201-8h-3l-1%201v-1c0-3-2-2-3%200l-4%202c-3%200-4%200-4%202-2%204-5%203-5-2l-1-4c-2%200-2%201-2%205m33-4l-2%202c-2%200-2%201-2%204v3h7c6%200%207%200%208-3l1-2v2c0%203%200%203%206%203h5v-3c0-3-1-4-4-4l-5-1h-3c-1%201-2%202-3%201l-3%201c-2%201-2%201-2-1-1-3-3-4-3-2m150%2081c-1%201-3%202-3%204-2%204-3%204-46%2021-34%2014-45%2018-46%2017-2-2-8-1-10%201l-2%203h-44l-44%201-3-2c-3-4-6-4-10%200l-2%202-44%201H62l-2-2c-4-4-6-4-10-1-7%207%203%2017%2010%2010l3-2%2044-1h44l2%202c4%204%206%204%2010%200l3-2%2044-1h45l1%202%205%202c3%200%208-4%208-5-2-2%204-5%2045-21%2040-16%2045-18%2046-16%207%204%2015-5%2010-11-2-2-6-3-9-2m0%2056c-2%201-4%205-4%208%200%201-8%209-23%2021l-23%2019H55l127%201%20127%201-21%2017c-20%2016-21%2018-25%2018s-5%201-7%203l-2%202-44%202-44%203-2-3c-3-3-8-3-11%201l-2%202H62l-2-2c-4-4-6-4-10-1-4%205-1%2012%204%2012a2461%202461%200%2001106%200l105-1a2000%202000%200%200050-2c-28%200-51%200-50-1l3-2a518%20518%200%2001101-24c4-5%201-10-4-10-3%200-7%203-7%205l-4%202-83%2020c-6%201-1-4%2021-22l24-20h49l-24-1h-23l21-18c20-17%2021-18%2025-17%203%200%204%200%206-3%205-6-2-13-9-10m-163%2098l-33%202c-1%201%2012%201%2046%201%2047%200%2047%200%2045-2s-1-2-58-1m-136%202c-1%201%2014%201%2045%201l45-1-45-1-45%201m-11%2010c-2%203-1%207%201%208l3-1h8c0%202%204%201%205-1v-5c-2-2-4-3-5%200l-2-1c-2-1-2-1-4%201h-2c-1-2-2-2-4-1m213%200c-2%202-2%204-1%206%200%202%204%202%205%200h1c1%202%205%203%205%201h2c3%202%205%201%205-3s-3-6-5-4c-1%202-1%202-3%200-1-1-1-1-3%201s-2%202-3%200c-2-2-2-2-3-1m85%201c-2%203%200%207%202%207l3-2h1c1%202%205%203%205%201h2c3%202%205%201%205-3s-2-6-5-3h-2c0-2-3-2-4%200-2%201-2%201-3-1-2-2-3-1-4%201m23-1c-3%202-2%208%201%208l3-2%201%201c2%202%205%201%205-2l1%201c1%203%205%203%206%200%200-3-1-7-3-7l-2%202-2%201c0-2-2-3-4-2l-1%202-2-1c-1-1-2-2-3-1m-196%2035l-1%201-3%201c-1%202-2%202-3%200-3-2-5%200-5%204%200%203%203%204%205%202h2c2%202%206%201%206-1v-8l-1%201m110%200l-1%201c-2%200-4%202-4%205%201%203%207%204%207%201h1c2%203%206%202%207-1%200-4-3-6-6-3l-2%202v-3l-1-3-1%201m-202%201l-5%201c-5%200-5%201-5%203l-1%202-1-2-1-3-1%203c0%203%201%204%205%204%203%200%204-1%204-2%200-3%201-3%202-1%202%203%206%203%207%200%200-3-2-6-4-5m232%201c-2%201-1%204%201%204l2%201h-4c0%202%201%202%205%202l4-1h2c2%202%205%201%205-2%200-2%200-2%202%200%201%204%203%204%204%200v-2l2%202c2%204%205%204%206%200l-1-4c-2-1-5%200-5%201h-3l-2%201-2-2h-3c0-1-2-1-3%201h-2l-2-1h-6\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/76b657620103638367aa6110aaeaeeeb/ca0a1/qXPSS.webp 223w", "/static/76b657620103638367aa6110aaeaeeeb/b1289/qXPSS.webp 389w"],
                "sizes": "(max-width: 389px) 100vw, 389px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/76b657620103638367aa6110aaeaeeeb/e92b6/qXPSS.png 223w", "/static/76b657620103638367aa6110aaeaeeeb/00a4e/qXPSS.png 389w"],
                "sizes": "(max-width: 389px) 100vw, 389px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/76b657620103638367aa6110aaeaeeeb/00a4e/qXPSS.png",
                "alt": "qXPSS",
                "title": "Second graph",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Second graph`}</figcaption>{`
  `}</figure></p>
    <p>{`As you can see, looking for primes is a bit of an exponential problem. However, if you have a linear solution I would absolutely love to see it.`}</p>
    <p>{`The more interesting part is how differently exponential it is with the same algorithm in different runtime environments. I have no idea what's going on with node.js on those large datasets. Both algorithms seem to be running on a nice exponential curve and then BAM, shoots through the roof and even dies completely. Whereas Clojure's biggest problem with the small datasets is apparently the run-up time itself and then it continues growing on a predictable exponential curve.`}</p>
    <h2 {...{
      "id": "conclusion"
    }}>{`Conclusion`}</h2>
    <p>{`My conclusion from all this is that despite everything, despite all the awesome optimiziations the V8 engine does, clojure is simply more appropriate when you're doing serious calculation on serious datasets. Go ahead and use node.js for everything nice and small, it's absolutely magnificent there.`}</p>
    <p>{`The next relevant test would probably input/output since that is supposedly node's strongpoint, but something tells me the story will be similar. Node better for small bursts of activity and clojure better for more sustained hardcore work.`}</p>
    <p>{`Let me know what you think, where did I fuck up this test?`}</p>
    <p>{`PS: I know clojure has type hinting, they proved to slow down the code.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      